import React from 'react';
import { Select } from 'antd';
import { FlexBox } from './style';

const { Option } = Select;

const optionSensor = ({ totalSensor, waterLevelSensor }) => {
  const sensorEntry = [];

  for (let i = 1; i <= totalSensor; i += 1) {
    sensorEntry.push(<Option key={`opt-${i}`} value={i}>{`Piezometer No.${i}`}</Option>);
  }

  if (waterLevelSensor) {
    sensorEntry.push(
      <Option key="opt-water-lv" value="waterLevel">
        Water level
      </Option>,
    );
  }

  return sensorEntry;
};

const PressureFilterSensor = ({
  totalSensor = 50,
  value = 1,
  handleChangeSensor,
  waterLevelSensor = false,
}) => (
  <FlexBox justify="space-between" itemsAlign="center" width="280px">
    <div>เลือกหัวอ่าน</div>
    <Select
      style={{ width: 200 }}
      optionFilterProp="children"
      value={value}
      onChange={(val) => handleChangeSensor(val)}
    >
      {optionSensor({ totalSensor, waterLevelSensor })}
    </Select>
  </FlexBox>
);

export default PressureFilterSensor;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureFilters/PressureFilterSensor.js